<template>
    <div>
        <i v-if="has('added')" class="fa fa-plus-circle" v-b-tooltip.hover title="Manually Added"></i>
        <i v-if="has('modified')" class="fa fa-pencil" v-b-tooltip.hover title="Modified"></i>
        <i v-if="has('disputed')" class="fa fa-exclamation-triangle" v-b-tooltip.hover title="Disputed"></i>
        <i v-if="has('time_excessive') || has('time_expire')" class="fa fa-clock-o" v-b-tooltip.hover :title="has('time_excessive') ? 'Excessive Visit Length' : 'Time Expired'"></i>
        <i v-if="has('hospital_stay')" class="fa fa-h-square" v-b-tooltip.hover title="Hospital Stay Indicated"></i>
    </div>
</template>

<script>
    export default {
        props: {
            flags: {
                type: Array,
                default() {
                    return [];
                },
            },
        },

        data: () => ({
        }),

        methods: {
            has(flag) {
                return this.flags.includes(flag);
            },
        }
    }
</script>
